import { doGet } from 'api/request';
import type { GlotUsageResponse } from 'api/resources/glotUsage/types';
import { LOGGER_TYPE } from 'api/types';

export const getGlotUsage = (accountId: string) =>
  doGet<GlotUsageResponse>(
    `accounts/${accountId}/glot-usage`,
    LOGGER_TYPE.AGENT_STREAM,
    { prefix: 'sourcerer', version: 'v1' },
  );
